import * as React from "react";
import * as csstips from "csstips";
import { style } from "typestyle";

interface IMapLayoutWithTwoSidebarsProps {
  left?: React.ReactNode;
  center: React.ReactNode;
  right?: React.ReactNode;
}

const sidebarCn = style({
  boxShadow: "0 0 8px 0 rgba(0,0,0,0.18), 0 0 8px 0 rgba(0,0,0,0.24)",
  height: "100%",
  position: "relative",
  zIndex: 1, // to make box-shadow visible
  display: "flex", // prevent overflow
});

const MapLayoutWithTwoSidebars = ({
  left,
  center,
  right,
}: IMapLayoutWithTwoSidebarsProps) => (
  <div className={style(csstips.fillParent, csstips.horizontal)}>
    {left && <div className={sidebarCn}>{left}</div>}
    <div className={style(csstips.fillParent, csstips.flex)}>{center}</div>
    {right && <div className={sidebarCn}>{right}</div>}
  </div>
);
export default MapLayoutWithTwoSidebars;
